import { Link } from "react-router-dom";
import {
  getComingSoonSuburbs,
  getLiveSuburbs,
  getSuburbPath,
} from "../data/suburbs";

const SuburbsIndexContent = () => {
  const liveSuburbs = getLiveSuburbs();
  const comingSoonSuburbs = getComingSoonSuburbs();

  return (
    <main className='suburb-page'>
      <section className='suburb-hero suburb-hero--index'>
        <div className='suburb-hero__overlay' />
        <div className='container suburb-hero__content suburb-hero__content--center'>
          <p className='suburb-hero__eyebrow'>Service Areas</p>
          <h1>Car Rental Suburbs We Serve</h1>
          <p className='suburb-hero__intro'>
            EZ Car Rentals provides affordable car, SUV, van and ute hire across
            Melbourne with convenient pickup from our Huntingdale depot.
          </p>
        </div>
      </section>

      <section className='suburb-section'>
        <div className='container'>
          <div className='suburb-section__header'>
            <h2>Available Now</h2>
            <p>Explore our live suburb landing page with full car hire details.</p>
          </div>
          <div className='suburbs-status-grid suburbs-status-grid--featured'>
            {liveSuburbs.map((suburb) => (
              <Link
                key={suburb.slug}
                to={getSuburbPath(suburb.slug)}
                className='suburbs-status-card suburbs-status-card--live suburbs-status-card--featured'
              >
                <span className='suburb-badge suburb-badge--live'>Available Now</span>
                <h3>{suburb.name}</h3>
                <p>Car rental in {suburb.name} and nearby areas</p>
                <span className='suburbs-index-card__arrow'>→</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className='suburb-section suburb-section--muted'>
        <div className='container'>
          <div className='suburb-section__header'>
            <h2>Coming Soon</h2>
            <p>
              We are rolling out dedicated pages for more suburbs across
              Melbourne. You can still request a quote for any area below.
            </p>
          </div>

          <div className='suburbs-status-grid'>
            {comingSoonSuburbs.map((suburb) => (
              <Link
                key={suburb.slug}
                to={getSuburbPath(suburb.slug)}
                className='suburbs-status-card suburbs-status-card--soon'
              >
                <span className='suburb-badge suburb-badge--soon'>Coming Soon</span>
                <h3>{suburb.name}</h3>
                <p>Local page launching shortly</p>
              </Link>
            ))}
          </div>

          <div className='suburb-index-cta'>
            <p>Need a vehicle now? We can help from our Huntingdale depot.</p>
            <div className='suburb-hero__actions suburb-hero__actions--center'>
              <Link to='/request-quote' className='reserve-now-btn'>
                Request a Quote
              </Link>
              <a href='tel:0400920512' className='reserve-now-btn suburb-btn-dark'>
                Call Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SuburbsIndexContent;
